import { colors } from 'assets/styled/tokens';
import styled from 'styled-components';

export const PageContent = styled.div`
  margin: 0 auto;
`;

export const PageContentHeader = styled.div`
  width: 100%;
  height: 32px;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
`;

export const KnowMoreLink = styled.a`
  text-decoration: none;
  font-family: Roboto;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.3px;
  text-align: right;
  color: #888888;
  svg {
    margin-left: 5px;
  }
`;

export const AgendaContainer = styled.div`
  width: 100%;
  min-height: 70vh;
  background-color: ${colors.white};
  box-shadow: 0px 1px 8px 0px #0000001a;
  border-radius: 8px;
`;

export const CalendarWrapper = styled.div`
  .rbc-calendar {
    border-radius: 8px;
    overflow: hidden;
  }
  .rbc-time-gutter {
    display: none;
  }
  .rbc-time-view {
    display: block;
    border: none;
  }
  .rbc-time-header-content {
    margin-left: 0 !important;
    border-top: 1px solid #ddd;
    border-left: none;
  }
  .rbc-header {
    padding-left: 0 !important;
    border-bottom: none;
    border-left: solid 1px #ddd;
    padding-top: 6px;
  }
  .rbc-label {
    padding: 0;
  }
  .rbc-time-header-gutter {
    display: none;
  }
  .rbc-time-content {
    border-top: none;
  }
  .rbc-time-header-content {
    border-bottom: none;
  }
  .rbc-day-slot.rbc-time-column:nth-of-type(2) > div:nth-child(25) {
    border-left: solid 1px red !important;
  }
  .rbc-timeslot-group {
    border-bottom: none;
  }
  .rbc-time-slot {
    border-top: none;
  }
  .rbc-current-time-indicator {
    display: none;
  }
  .rbc-allday-cell {
    display: none;
  }
  .rbc-header .rbc-current-day-column-header {
    border-bottom: none;
    box-sizing: border-box;
  }
  .rbc-time-content .rbc-current-day-column-body {
    border-top: none;
    box-sizing: border-box;
  }

  .rbc-header.rbc-today {
    border-top: 1px solid #dc7c00;
    border-left: 1px solid #dc7c00;
    border-right: 1px solid #dc7c00;
  }

  .rbc-time-column.rbc-today {
    border-bottom: 1px solid #dc7c00;
    border-left: 1px solid #dc7c00;
    border-right: 1px solid #dc7c00;
  }
  .rbc-event-label {
    display: none;
  }
  .rbc-event {
    border: none;
    padding: 0;
    background-color: transparent;
    top: 0;
    left: 0;
    width: auto;
    height: auto;
  }
  .rbc-event-content {
    display: flex;
    justify-content: center;
  }
`;

interface CardProps {
  background?: string;
  border?: string;
}

export const Card = styled.div<CardProps>`
  background-color: ${props => props.background};
  border-left: 4px solid ${props => props.border};
  width: 155px;
  height: 96px;
  border-radius: 4px;
  box-sizing: border-box;
  padding: 4px;
  font-size: 12px;
  color: ${colors.carbon};
  display: flex;
  flex-direction: column;
  font-family: Roboto;
  position: relative;
  justify-content: space-evenly;
`;

interface FirstRowProps {
  font?: string;
}

export const FirstRow = styled.div<FirstRowProps>`
  font-weight: 700;
  font-size: 12px;
  line-height: 100%;
  letter-spacing: 0px;
  color: ${props => props.font};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 120px;
  height: 12px;
  display: block;
`;

export const SecondRow = styled.div`
  font-weight: 700;
  font-size: 12px;
  line-height: 100%;
  letter-spacing: 0px;
  color: ${colors.carbon};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 120px;
  height: 12px;
  display: block;
`;

export const ThirdRow = styled.div`
  font-weight: 400;
  font-size: 12px;
  line-height: 100%;
  letter-spacing: 0px;
  color: ${colors.carbon};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 120px;
  height: 12px;
  display: block;
`;

export const FourthRow = styled.div`
  font-weight: 400;
  font-size: 12px;
  line-height: 100%;
  letter-spacing: 0px;
  color: ${colors.carbon};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 120px;
  height: 12px;
  display: block;
`;

export const FifthRow = styled.div`
  font-weight: 400;
  font-size: 12px;
  line-height: 100%;
  letter-spacing: 0px;
  color: ${colors.carbon};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 120px;
  height: 12px;
  display: block;
`;

interface InternalBorderProps {
  border?: string;
}

export const InternalBorder = styled.div<InternalBorderProps>`
  width: 100%;
  height: 1px;
  background-color: ${props => props.border};
`;

export const TodayBox = styled.div`
  font-family: Roboto;
  font-weight: 700;
  font-size: 12px;
  line-height: 100%;
  letter-spacing: 0px;
  text-align: center;
  color: #fff;
  background-color: ${colors.primary};
  border-bottom-right-radius: 4px;
  position: absolute;
  left: 0;
  top: -6px;
  padding: 3px 6px 3px 4px;
`;

export const TotalHours = styled.div`
  font-family: Roboto;
  font-weight: 400;
  font-size: 12px;
  line-height: 100%;
  letter-spacing: 0px;
  text-align: center;
  color: ${colors.gray};
`;
